import React from "react";
import validator from "validator";
export const regex = {
  nombre: {
    value: /^[A-Za-záÁéÉíÍóÓúÚñÑüÜ.&\s]+$/,
    mensaje: "Solo puede ingresar letras",
  },
  regexRazonSocial: /^[0-9a-zA-ZáÁéÉíÍóÓúÚñÑüÜ& \-\w]*$/,
  codPostal: {
    value: /^[0-9]{5}$/,
    mensaje: "El código debe tener 5 dígitos",
  },
  telefono10: {
    value: /^[0-9]{10}/,
    mensaje: "El campo debe contener solo dígitos` ",
  },
  requiredMessage: "Este campo es obligatorio",
};
